function initProductTracking() {
  function getProductData(variantId = null) {
    const productDataEle = document.querySelector('input[data-tracking-product]')
    const productData = JSON.parse(productDataEle.dataset.trackingProduct);
    const { variants, title, vendor, type } = productData;
    const variantData = getSelectedVariant(variants, variantId)
    const { sku, title: variantTitle, price } = variantData
    const collectionDataEle = document.querySelector('[data-tracking-collection]');
    const collectionData = JSON.parse(collectionDataEle.dataset.trackingCollection);
    let [collectionTitle, collectionHandle] = ['All', 'all']
    if (collectionData != null) {
      let { title, handle } = collectionData;
      [collectionTitle, collectionHandle] = [title, handle];
    }
    let productType = type
    if (productType === "") {
      const typeTags = productData.tags.filter(tag => tag.startsWith('Product Type'));
      const subtypeTags = productData.tags.filter(tag => tag.startsWith('Product Subtype'));
      let subtypes = subtypeTags || typeTags || "";
      if (typeof subtypes !== "string") {
          const splitTags = subtypes.map(tag => tag.split(': ')[1])
          subtypes = splitTags.join(' / ')
      }
      productType = subtypes.trim()
    }
    return [
      {
        item_id: sku,
        item_name: title,
        affiliation: Shopify.shop,
        currency: Shopify.currency.active,
        discount: trackingFormatPrice(trackingGetProductDiscount(productData)),
        index: 0,
        item_brand: vendor,
        item_category: productType,
        item_list_id: collectionHandle,
        item_list_name: collectionTitle,
        item_variant: variantTitle,
        price: trackingFormatPrice(price),
        quantity: 1
      }
    ]
  }

  function viewItem(variantId = null) {
    const data = getProductData(variantId);
    pushToDataLayer("dlv_view_item", data)
  }

  function getSelectedVariant(variants, variantID) {
    if (variantID == null) return variants[0]
    const selectedVariant = variants.find(variant => variant.id === variantID);
    return selectedVariant;
  }

  function handleAddToCart(button) {
    const quantity = button.dataset.qty;
    const productData = JSON.parse(button.dataset.trackingProduct);
    const { variants, title, vendor, type } = productData;

    const variantID = +button.form.querySelector('input[name="id"]').value;
    const selectedVariant = getSelectedVariant(variants, variantID);
    const { sku, title: variantTitle, price } = selectedVariant;

    const collectionDataEle = document.querySelector('[data-tracking-collection]');
    const collectionData = JSON.parse(collectionDataEle.dataset.trackingCollection);
    let [collectionTitle, collectionHandle] = ['All', 'all']

    if (collectionData != null) {
      let { title, handle } = collectionData;
      [collectionTitle, collectionHandle] = [title, handle];
    }   

    let isSubscription = false;
    let deliveryFrequency = null;

    const rechargeWidgetId = document.querySelector("div[id^=RechargeWidget_]").id.split("_")[1];
    const rechargeWidgetData = window.Recharge.widgets[rechargeWidgetId];

    const selectedSellingPlan = rechargeWidgetData?.state.sellingPlan

    if (rechargeWidgetData?.product.selling_plan_groups?.length > 0) {
      rechargeWidgetData?.product.selling_plan_groups[0].selling_plans.forEach((e) => {
        if (e.selling_plan_id == selectedSellingPlan) {
          deliveryFrequency = e.order_interval_frequency;
        }
      });
    }

    const subscriptionRadioActive = document.querySelector('.rc-radio--active.subscription-radio');

    if (deliveryFrequency && subscriptionRadioActive != null) {
      isSubscription = true;
    }

    let productType = type
    if (productType === "") {
      const typeTags = productData.tags.filter(tag => tag.startsWith('Product Type'));
      const subtypeTags = productData.tags.filter(tag => tag.startsWith('Product Subtype'));
      let subtypes = subtypeTags || typeTags || "";
      if (typeof subtypes !== "string") {
        const splitTags = subtypes.map(tag => tag.split(': ')[1])
        subtypes = splitTags.join(' / ')
      }
      productType = subtypes.trim()
    }

    const product_type_data = {
      product_type: isSubscription ? "subscription" : "otp",
      delivery_frequency: isSubscription ? deliveryFrequency : null
    }

    const data = [
      {
        item_id: sku,
        item_name: title,
        affiliation: Shopify.shop,
        coupon: "COUPON - ADD LATER",
        currency: Shopify.currency.active,
        discount: trackingFormatPrice(trackingGetProductDiscount(selectedVariant)),
        index: 0,
        item_brand: vendor,
        item_category: productType,
        item_list_id: collectionHandle,
        item_list_name: collectionTitle,
        item_variant: variantTitle,
        price: trackingFormatPrice(price),
        quantity: quantity || 1
      }
    ]

    pushToDataLayer("dlv_add_to_cart", data, product_type_data)
  }

  function addAddToCartHandlers() {
    const addToCartButtons = document.querySelectorAll('form[action="/cart/add"] [type="submit"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', () => handleAddToCart(button))
    })
  }

  viewItem();
  addAddToCartHandlers();
}


function initCartPageTracking() {
  function formatProductData(productData, index) {
    const { sku, name, vendor, product_type, variant_title, price, quantity } = productData
    return {
      item_id: sku,
      item_name: name || productData.title,
      affiliation: Shopify.shop,
      currency: Shopify.currency.active,
      discount: trackingFormatPrice(trackingGetProductDiscount(productData)),
      index,
      item_brand: vendor,
      item_category: product_type,
      item_list_id: "all",
      item_list_name: "All",
      item_variant: variant_title,
      price: trackingFormatPrice(price),
      quantity: quantity
    }
  }

  function getCartProductData() {
    const productEles = [...document.querySelectorAll('.cart-item-row')]
    const items = productEles.map((ele, index) => formatProductData(JSON.parse(ele.dataset.cartTrackingData, index)))
    return items;
  }

  function handleViewCart() {
    const data = {
      product_type: "otp",
      delivery_frequency: null,
      items: getCartProductData()
    };
    let value = document.querySelector('#subtotal').innerHTML.trim().replace("$", "").replace("£", "").replace("€", "");
    pushToDataLayer("view_cart", data, null, Shopify.currency.active, value);
  }

  function ajaxCartObserverCallback(mutationList, observer) {
    handleViewCart();
    observer.disconnect()
  }
  const ajaxCartObserverConfig = { attributes: true, childList: true, subtree: true };
  const ajaxCartObserver = new MutationObserver(ajaxCartObserverCallback)
  const ajaxCartEle = document.querySelector('cart-notification');
  ajaxCartObserver.observe(ajaxCartEle, ajaxCartObserverConfig);
}

function cartProductAmountChange(lineItemData, collectionData, increase, quantityChange) {
  console.log(lineItemData);

  dataLayer.push({
    event: increase ? "dlv_add_to_cart" : "remove_from_cart",
    ecommerce: {
      product_type: "otp",
      delivery_frequency: null,
      items: [
        {
          item_id: lineItemData.sku,
          item_name: lineItemData.product_title,
          affiliation: Shopify.shop,
          currency: Shopify.currency.active,
          discount: lineItemData.line_level_total_discount,
          index: null,
          item_brand: lineItemData.vendor,
          item_category: lineItemData.product_type,
          item_list_id: "all", //lineItemData
          item_list_name: "All", //lineItemData
          item_variant: lineItemData.variant_title,
          price: trackingFormatPrice(lineItemData.price),
          quantity: quantityChange || lineItemData.quantity
        }
      ]
    }
});


}

function removeLineFromCart(lineItemData) {

  dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      product_type: "otp",
      delivery_frequency: null,
      items: [
        {
          item_id: lineItemData.sku,
          item_name: lineItemData.product_title,
          affiliation: Shopify.shop,
          currency: Shopify.currency.active,
          discount: lineItemData.line_level_total_discount,
          index: null,
          item_brand: lineItemData.vendor,
          item_category: lineItemData.product_type,
          item_list_id: "all", //lineItemData
          item_list_name: "All", //lineItemData
          item_variant: lineItemData.variant_title,
          price: trackingFormatPrice(lineItemData.price),
          quantity: lineItemData.quantity
        }
      ]
    }
});

}

initCartPageTracking();
initProductTracking();